import { ChangeDetectionStrategy, Component, computed, inject, input, OnInit, output, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DatatableComponent, NgxDatatableModule } from '@swimlane/ngx-datatable';

import { TableService } from '../../../services/table/table.service';
import { FormsModule } from '@angular/forms';
import { SmoothViewportScroller } from '@smartcharge/shared/services/smooth-viewport-scroller.service';

@Component({
  selector: 'sc-datatable-footer',
  templateUrl: './datatable-footer.component.html',
  styleUrls: ['./datatable-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, NgxDatatableModule, TranslateModule]
})
export class DatatableFooterComponent implements OnInit {
  readonly tableName = input.required<string>();
  readonly rowCount = input<number>(0);
  readonly selectedCount = input<number>(0);
  readonly pageSizeOptions = input<number[]>([10, 25, 50]);

  readonly pageSizeChange = output<number>();

  readonly offset = () => this.datatable.offset + 1;

  pageSize = 10;

  private readonly tableService = inject(TableService);
  private readonly datatable = inject(DatatableComponent, { host: true });
  private readonly viewportScroller = inject(SmoothViewportScroller);

  ngOnInit(): void {
    const configuration = this.tableService.getConfiguration(this.tableName());

    if (configuration.limit && configuration.limit !== this.pageSize) {
      this.pageSize = configuration.limit;
      this.viewportScroller.scrollToElement(this.datatable.element);
    }
  }

  onPageChange(event: { page: number; size: number; count: number }): void {
    this.viewportScroller.scrollToElement(this.datatable.element);
    this.datatable.onFooterPage(event);
  }

  onPageSizeChange(value: string | number, shouldScroll = true): void {
    const nextPageSize = typeof value === 'string' ? Number(value) : value;

    if (!Number.isFinite(nextPageSize) || nextPageSize <= 0 || nextPageSize === this.pageSize) {
      return;
    }

    this.tableService.setConfiguration(this.tableName(), { limit: nextPageSize });

    if (this.pageSize !== nextPageSize) {
      this.datatable.offset = 0;
      this.pageSize = nextPageSize;
    }

    if (shouldScroll) {
      this.viewportScroller.scrollToElement(this.datatable.element);
    }

    this.pageSizeChange.emit(nextPageSize);
  }
}
